export default __webpack_public_path__ + "8f4231c0cfa69e9a2b704d43c2ed44ee.woff2";